import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { GenericImportPage } from '@driftt/crm-components'
import {
  Div,
  H3,
  Li,
  Ul 
} from '@driftt/tide-core'
import {
  forceFetchFromHubSpot,
  getHubspotLists,
  pauseHubspotLists,
  syncHubspotLists 
} from 'api/imports'
import {
  getOrgHubspotAccessType,
  HubspotAccessTypes,
  shouldShowHubspotImports 
} from 'utils/hubspotAccess'

import HubspotImportTableConfig from './HubspotImportTableConfig'

import './style.css'

const hasAccessToHubspotImport = () => {
  const hasAccess = getOrgHubspotAccessType() === HubspotAccessTypes.HAS_ACCESS_CONNECTED

  return shouldShowHubspotImports() && hasAccess
}

const ListTypes = [
  {
    key: 'DYNAMIC',
    displayName: 'Dynamic List',
    displayNamePlural: 'Dynamic Lists',
    iconKey: 'lightning-bolt'
  },
  {
    key: 'STATIC',
    displayName: 'Static List',
    displayNamePlural: 'Static Lists',
    iconKey: 'list-bullets'
  }
]

const ModalBody = () => (
  <Div className="hubspot-import--modal-body">
    <H3>HubSpot sync information</H3>
    <Ul>
      <Li>Imported lists will be saved as Drift segments</Li>
      <Li>Drift only syncs contacts that have an email address</Li>
    </Ul>
  </Div>
)

const fetchHubspotLists = async ({
  query,
  type 
}) => {
  const data = await getHubspotLists({
    query,
    type 
  })

  return data.data
}

const fetchFromHubSpotOnPageLoad = () => {
  return forceFetchFromHubSpot({ force: false })
}

const fetchFromHubSpot = () => {
  return forceFetchFromHubSpot({ force: true })
}

const mapStateToProps = state => ({ bootstrapComplete: state.config.bootstrapComplete })


const HubspotImport = ({ bootstrapComplete }) => {
  if(!bootstrapComplete) {return null}

  if (!hasAccessToHubspotImport()) {
    return (
      <Redirect to="/imports" />
    )
  }

  return (
    <GenericImportPage
      title="Import HubSpot Lists"
      integrationId="HUBSPOT"
      integrationDisplayName="HubSpot"
      fetchLists={fetchHubspotLists}
      fetchInitialData={fetchFromHubSpotOnPageLoad}
      refreshLists={fetchFromHubSpot}
      syncLists={syncHubspotLists}
      pauseLists={pauseHubspotLists}
      listTypes={ListTypes}
      tableConfig={HubspotImportTableConfig}
      modalBody={ModalBody}
    />
  )
}

export default connect(mapStateToProps)(HubspotImport)
